import { render } from "./WorkModal.vue?vue&type=template&id=11a67ed2&scoped=true&ts=true"
import script from "./WorkModal.vue?vue&type=script&lang=ts"
export * from "./WorkModal.vue?vue&type=script&lang=ts"

import "@/components/SelectedWork/WorkModal/style.scss?vue&type=style&index=0&id=11a67ed2&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a67ed2"]])

export default __exports__